import { useEffect, useState } from 'react';
import Hero from './components/Hero';
import Problem from './components/Problem';
import Solution from './components/Solution';
import ServiceFlow from './components/ServiceFlow';
import Strengths from './components/Strengths';
import Profile from './components/Profile';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <div className="min-h-screen bg-white">
      {/* Header Navigation */}
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-sm'
        }`}
      >
        <nav className="px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="/assets/logo.png"
              alt="EngiMind Logo" 
              className="h-10 w-auto"
            />
            <div className="flex flex-col">
              <span className="text-[#1A3A5C] font-bold text-xl tracking-wide">EngiMind</span>
              <span className="text-[#4A5568] text-xs">エンジマインド</span>
            </div>
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('service')}
              className="text-[#4A5568] hover:text-[#1A3A5C] transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              サービス内容
            </button>
            <button
              onClick={() => scrollToSection('profile')}
              className="text-[#4A5568] hover:text-[#1A3A5C] transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              プロフィール
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#4A5568] hover:text-[#1A3A5C] transition-colors text-sm font-medium whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </button>
          </div>

          {/* Hamburger Button (Mobile) */}
          <button
            className="md:hidden flex flex-col justify-center items-center w-8 h-8 gap-1.5 cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニュー"
          >
            <span className={`block w-6 h-0.5 bg-[#1A3A5C] transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
            <span className={`block w-6 h-0.5 bg-[#1A3A5C] transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-0.5 bg-[#1A3A5C] transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
          </button>
        </nav>

        {/* Mobile Dropdown Menu */}
        {menuOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 shadow-md px-6 py-4 flex flex-col gap-4">
            <button
              onClick={() => scrollToSection('service')}
              className="text-[#4A5568] hover:text-[#1A3A5C] transition-colors text-sm font-medium text-left whitespace-nowrap cursor-pointer"
            >
              サービス内容
            </button>
            <button
              onClick={() => scrollToSection('profile')}
              className="text-[#4A5568] hover:text-[#1A3A5C] transition-colors text-sm font-medium text-left whitespace-nowrap cursor-pointer"
            >
              プロフィール
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-[#4A5568] hover:text-[#1A3A5C] transition-colors text-sm font-medium text-left whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </button>
          </div>
        )}
      </header>

      {/* Main Content */}
      <main className="pt-20">
        <Hero />
        <Problem />
        <Solution />
        <ServiceFlow />
        <Strengths />
        <Profile />
        <Contact />
      </main>

      <Footer scrollToSection={scrollToSection} />
    </div>
  );
}